<template>
  <v-dialog
    v-model="planWizardDialog"
    width="500"
    style="margin:0!important;"
    content-class="plan-wizard"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    no-click-animation
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn
          v-if="step != 'choose-pack' && step != 'see-packs'"
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        v-if="step == 'almost-done'"
      >
        <v-layout
          wrap
          justify-center
        >
          <v-flex
            text-center
            mt-10
            mb-10
          >
            <v-progress-circular
              :size="40"
              color="primary"
              class="mb-2"
              indeterminate
            /><br>
            <b>{{ $t('packs.almostDone') }}</b>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text
        v-if="step == 'see-packs'"
        class="step-1 mt-10"
      >
        <v-flex
          xs12
          text-center
        >
          <v-icon class="main-icon mb-4">
            {{ emotion ? 'mdi-emoticon-excited-outline' : 'mdi-check-circle-outline' }} 
          </v-icon>
        
          <span class="step-title">{{ $t('packs.choosePack') }}</span>
        
          <v-layout
            wrap
            class="bullets mt-3"
            :class="$vuetify.breakpoint.xs ? 'ml-0' : 'ml-10'"
          >
            <v-flex
              xs1
              mb-3
              mt-3
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              xs11
              mt-3
              mb-3
            >
              <b>{{ $t('packs.noPayments') }}</b><br>
            </v-flex>
            <v-flex xs1>
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex xs11>
              <b>{{ $t('packs.chooseUpTo') }}</b>
            </v-flex>
          </v-layout>
          <v-btn
            class="primary mt-5 mb-5"
            large
            @click="choosePack()"
            @mouseover="emotion = true"
            @mouseleave="emotion = false"
          >
            {{ $t("packs.seePackagesButton") }}
          </v-btn>
          <v-flex>
            <v-divider />
          </v-flex>
          <v-btn
            class="mt-5"
            text
            small
            @click="switchToTrader()"
          >
            {{ $t('packs.iAmtrader') }}
          </v-btn><br>
          <v-btn
            class="mb-5"
            text
            small
            @click="choosePack()"
          >
            {{ $t('packs.iAmPartner') }}
          </v-btn>
        </v-flex>
      </v-card-text>
      <v-card-text
        v-if="step == 'choose-pack'"
      >
        <span class="step-title">{{ $t('packs.chooseRightPack') }}</span><br>
        {{ $t('packs.lifeTypeUsage') }}
        <packs
          :is-partner="isPartner"
          :is-partner-checked="true"
          @setProducts="setProducts"
        />
      </v-card-text>
      <v-card-text
        v-if="step == 'make-call'"
      >
        <make-call @makeCall="makeCall" />
      </v-card-text>
      <v-card-text
        v-if="step == 'show-shedule'"
        class="pa-0"
      >
        <iframe
          width="100%"
          height="620"
          class="meetings-iframe-container"
          src="https://meetings.hubspot.com/dch2?embed=true"
          frameborder="0"
        />
        <div class="shedule-cover" />
      </v-card-text>
      <v-card-text
        v-if="step == 'accept-terms'"
      >
        <accept-terms
          @acceptTerms="acceptTerms"
        />
      </v-card-text>
      <v-card-text
        v-if="step == 'gateways'"
      >
        <gateways
          :invoice-id="invoice.id"
          @closeDialog="closeDialog"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>

import AcceptTerms from "@/views/Packs/partial/AcceptTerms.vue";
import Packs from "@/views/Packs/partial/Packs.vue";
import MakeCall from "@/views/Packs/partial/MakeCall.vue";
import Gateways from "@/views/Gateway/partial/Gateways.vue";

import UPDATE_USER_MUTATION from "@/graphql/mutations/UpdateUser.gql";
import CREATE_ORDER_MUTATION from '@/graphql/mutations/CreateOrder.gql';
import { mapMutations, mapGetters } from "vuex";

export default {
  name: 'HelperPlanWizard',
  components: {
    Packs,
    MakeCall,
    AcceptTerms,
    Gateways
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    step: 'see-packs',
    termsAccepted: false,
    invoice: null,
    products: [],
    emotion: false
  }),
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("invoice", ["getPending"]),
    planWizardDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closePlanWizardDialog", val);
      }
    },
    isPartner: {
      get() {
        return (this.getUser && this.getUser.sponsor != null)
      },
      set(val) {}
    }
  },
  mounted() {
    var scripts = [
      "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js",
    ];
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.head.appendChild(tag);
    });
    
  },
  methods: {
    ...mapMutations("user", ["setFreePack"]),
    ...mapMutations("app", ["setTraderMode"]),
    ...mapMutations("invoice", ["setPending"]),
    setProducts(products) {
      this.products = products
      this.buyPack()
    },
    acceptTerms(val) {
      this.termsAccepted = val
      this.step = 'almost-done'
      this.buyPack()
    },
    makeCall(val) {
      if (val) {
        this.step = 'show-shedule'
        return
      }
      this.closeDialog()
    },
    buyPack() {
      if (this.products[0] == 0) {
        this.mutateFreePack()
        this.step = 'make-call'
        return;
      }
      
      if (!this.termsAccepted) {
        this.step = 'accept-terms'
        return
      }

      if (this.getUser && !this.getUser.free_pack) {        
        this.mutateFreePack()
      }
      this.createOrder()
    },
    createOrder() {
      this.loading = true
      const freeIndex = this.products.indexOf(0);
      if (freeIndex > -1) {
        this.products.splice(freeIndex, 1)
      }
      this.$apollo.mutate({
          mutation: CREATE_ORDER_MUTATION,
          variables: {
            product_ids: this.products
          }       
      }).then(data => {       
          this.invoice = data.data.createOrder.invoice
          this.setPending(this.invoice.id)
          this.step = 'gateways';
          this.loading = false;
      }).catch(error => {
          this.loading = false; 
          this.errorHandler(error) 
      })
    },
    mutateFreePack() {
      let form = {
        free_pack: true
      }
      this.$apollo
      .mutate({
        mutation: UPDATE_USER_MUTATION,
        variables: form
      })
      .then(data => {
        this.setFreePack(data.data.updateUser.free_pack)
        gtag('event', 'Free Package Selected', {
          'event_category': 'Package Sales',
          'event_label': 'Packages Form',
        });
      });
    },
    switchToTrader() {
      gtag('event', 'Im Trader Clicked', {
        'event_category': 'Package Sales',
        'event_label': 'Packages Form',
      });
      localStorage.setItem("trader-mode", true);
      this.mutateFreePack();
      this.closeDialog()
      this.setTraderMode(true);
      this.$router.push('/projects');
    },
    choosePack(val) {
      gtag('event', 'Choose Package Clicked', {
        'event_category': 'Package Sales',
        'event_label': 'Packages Form',
      });
      this.isPartner = val
      this.step = 'choose-pack'
    },
    closeDialog() {
      this.planWizardDialog = false
      if (this.getPending != null) {
        this.$router.push(`/invoice/${this.getPending}`)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/material-dashboard/_colors.scss";
.plan-wizard {
  .step-title {
    font-weight: 700;
    font-size: 26px;
  }
  .step-1 {
    .bullets {
      font-size:16px;
      max-width:350px;
      text-align: left;
    }
    .main-icon {
      text-align: center;
      font-size: 70px;
      display: block;
      color: $purple!important;
      font-weight: bold;
    }
  }
  .shedule-cover {
    height: 100px;
    position: relative;
    top: -80px;
    background-color: #fff;
  }
}


</style>
